/**
 * Agent Trace Dashboard Page
 * 
 * Dedicated page for real-time monitoring and debugging of all agent API calls.
 * Provides comprehensive visibility into the agent execution flow.
 */

import React from 'react';
import { AgentTraceMonitor } from '@/components/AgentTraceMonitor';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function AgentTraceDashboard() {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col bg-background">
      {/* Top Navigation */}
      <div className="h-16 border-b flex items-center px-6 bg-card">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(-1)}
          className="mr-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <div className="flex-1">
          <h1 className="text-xl font-bold">Agent API Trace Dashboard</h1>
          <p className="text-sm text-muted-foreground">
            Real-time monitoring of all agent API calls and orchestration flow
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 min-h-0">
        <AgentTraceMonitor />
      </div>
    </div>
  );
}
